import { create } from 'zustand';
import type { CoinSymbol } from '@asia/shared';

export type Tab = 'wallet' | 'cards' | 'profile';

// Full-screen routes pushed on top of the current tab (Telegram-style stack).
export type Route =
  | { name: 'send'; coin?: CoinSymbol }
  | { name: 'receive' }
  | { name: 'buy' }
  | { name: 'qr' }
  | { name: 'coin'; coin: CoinSymbol }
  | { name: 'history' }
  | { name: 'wallets' }
  | { name: 'walletList' }
  | { name: 'seed'; walletId?: string }
  | { name: 'issueCard' }
  | { name: 'cardSettings'; cardId: string }
  | { name: 'faq' }
  | { name: 'support' }
  | { name: 'email' }
  | { name: 'pin' }
  | { name: 'biometric' }
  | { name: 'sessions' }
  | { name: 'referral' };

interface NavState {
  tab: Tab;
  stack: Route[];
  setTab: (t: Tab) => void;
  push: (r: Route) => void;
  pop: () => void;
  reset: () => void;
  current: () => Route | null;
}

export const useNav = create<NavState>((set, get) => ({
  tab: 'wallet',
  stack: [],
  setTab: (tab) => set({ tab, stack: [] }),
  push: (r) => set((s) => ({ stack: [...s.stack, r] })),
  pop: () => set((s) => ({ stack: s.stack.slice(0, -1) })),
  reset: () => set({ stack: [] }),
  current: () => {
    const s = get().stack;
    return s.length ? s[s.length - 1]! : null;
  },
}));
